import React from 'react';

import { find } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Tooltip } from 'modules/tooltip';

// mood icon names based on option name
const MOOD_ICONS = {
    angry: 'faceAngry',
    sad: 'faceSad',
    neutral: 'faceNeutral',
    happy: 'faceHappy',
};

/**
 * @desc Data cell view for single or mult-select data cells.
 * @example
 * import { simpleText as SimpleTextCellView } from './cellViews/simpleText.view';
 */
export const moodSelect = ( props ) => {

    const option = find( props.options, { value: props.value.value } );
    
	return (
        <div className='ui-table-cell-view-mood-select'>

        {/* options */}
        <div className='ui-table-cell-view-mood-select__options'>
                 <Tooltip
                 title={ getLabel( 'displayTextMood' ) }
                 text={ getLabel( option.title ) }
                 render={ ( binding = {} ) => (
                     <div
                         { ...binding }
                         className='ui-table-cell-view-mood-select__options__item--active'
                     >
                         <Icon name={ MOOD_ICONS[ option.name ] } />
                     </div>
                 ) }
             />
        </div>
    </div>
	);
};
